/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceType } from '../models/ResourceType';
import { ScalarOperators } from '../models/ScalarOperators';

export class ResourceTypeCondition {
  'operator': ScalarOperators;
  /**
  * Resource types to evaluate. `RESOURCE_TYPE_UNSPECIFIED` is supported only in responses. 
  */
  'resourceTypes': Array<ResourceType>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "operator",
      "baseName": "operator",
      "type": "ScalarOperators",
      "format": ""
    },
    {
      "name": "resourceTypes",
      "baseName": "resourceTypes",
      "type": "Array<ResourceType>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ResourceTypeCondition.attributeTypeMap;
  }

  public constructor() {
  }
}



